export const ProductPrice = ({ product, size = "md", testId }) => {
  const big = size === "lg";
  if (!product.price) {
    return <span className={`${big ? "text-base" : "text-sm"} font-semibold text-slate-300`} data-testid={testId}>Call for price</span>;
  }
  return (
    <span className="inline-flex items-baseline gap-2 flex-wrap" data-testid={testId}>
      <span className={`${big ? "text-2xl" : "text-base"} font-bold text-white`}>{product.price}</span>
      {product.mrp && <span className={`${big ? "text-sm" : "text-xs"} text-slate-500 line-through`}>{product.mrp}</span>}
      {product.discount && (
        <span className="text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-md bg-[#D48C46] text-slate-950" data-testid={testId ? `${testId}-discount` : undefined}>{product.discount}</span>
      )}
    </span>
  );
};
